export const UserPermissionGroupIDs = {
    SUPER_ADMIN: 1,
    GROUP_ADMIN: 2,
    USER: 3,
};

export const UserIndustryTypeID = {
    CONTRACTOR: 1,
};

export const UserRoleID = {
    OTHER: 5,
};

export const UserUrlsPermissionsID = {
    EDIT_COMPLETED_AUDITS: 1,
    CAN_SEE_ALL_ACTIVE_INSPECTIONS_BY_DEFAULT: 2,
};
